import { patch } from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { ProductOrder } from "@project/types/gruh-udhyog";
import { JIVANDHARA_BASE, fetchListPage, unwrapItem } from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/product-orders`;

class GruhUdhyogOrderService {
  listPage = (query: ListQuery = {}): Promise<PaginatedResult<ProductOrder>> =>
    fetchListPage<ProductOrder>(`${BASE}/`, query);

  updateStatus = async (
    id: number,
    orderStatus: string
  ): Promise<ProductOrder | undefined> => {
    const data = await patch<
      ApiItemResponse<ProductOrder> | ProductOrder,
      { order_status: string }
    >(`${BASE}/${id}/`, { order_status: orderStatus });
    return unwrapItem(data);
  };
}

export const gruhUdhyogOrderService = new GruhUdhyogOrderService();
